<template>
  <div class="p-3 md:py-4 md:px-6 bg-idle-white mt-4 rounded-md">
    <TsTypography :variant="isMobile ? 'base': 'h3'" append-class="text-idle-black">{{
      useTranslation(
        "Checkout-taxInformation",
        "Belastinggegevens, indien van toepassing"
      )
    }}</TsTypography>
    <TsRow
      no-gutter
      isMultiline
      append-class="gap-2 mb-2"
    >
      <TsColumn class="max-md:is-12">
        <TsInput v-model="checkoutStore.companyName" :placeholder="businessName"></TsInput>
      </TsColumn>
      <TsColumn class="max-md:is-12">
        <TsInput v-model="checkoutStore.companyVatNumber" :placeholder="taxNumber"></TsInput>
      </TsColumn>
    </TsRow>
  </div>
  <TsCheckbox
    v-if="props.showMarketingCommunication"
    v-model="hasOptedForEmailMarketing"
    size="sm"
    data-testid=""
    label-class="text-xs text-natural-grey"
    append-class="items-start my-3 md:my-4"
    :label="newsLettersMessage"
  />
  <TsTypography
  append-class="text-xs text-natural-grey mt-2 mb-2"
>
  {{
    useTranslation(
      "orderContactPermission",
      "Wij mogen contact met je opnemen via e-mail of telefoon als er iets mis is met je bestelling."
    )
  }}
</TsTypography>
</template>

<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";

const TsCheckbox = defineAsyncComponent(
  () => import("~/components/atoms/TsCheckbox.vue")
);

type Props = {
  showMarketingCommunication?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  showMarketingCommunication: true,
});

const {isMobile} = useDevice();
const checkoutStore = useCheckoutStore();

const hasOptedForEmailMarketing = defineModel("offers-preference");
const businessName = useTranslation("Checkout-businessName", "Bedrijfsnaam");
const taxNumber = useTranslation("Checkout-taxNumber", "Belastingnummer");
const newsLettersMessage = useTranslation(
  "Checkout-newsLetterMessage",
  "Ja, ik wil Toolstation-nieuwsbrieven ontvangen waarmee ik op de hoogte blijf van aanbiedingen, nieuwe producten en professionele tips."
);
</script>
